import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useCallback, useEffect, useState } from 'react';

dayjs.extend(relativeTime);

const REFRESH_INTERVAL_MS = 15000;

// This hook is used to display a human-readable time difference from the current time, e.g. "5 minutes ago".
// It refreshes every 15 seconds to keep the information up to date.
export const useTimeAgo = (timestamp: string | null | undefined) => {
  const [timeAgo, setTimeAgo] = useState<string>();

  const updateTimeAgo = useCallback(
    () => setTimeAgo(dayjs(timestamp ?? undefined).fromNow()),
    [timestamp]
  );

  useEffect(() => {
    updateTimeAgo();
    const interval = setInterval(updateTimeAgo, REFRESH_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [updateTimeAgo]);

  return timeAgo;
};
